import React from 'react';

import './exit.scss';

class Exit extends React.Component {
  render() {
    return <div className="exit"></div>;
  }
}

export default Exit;
